import React, { Fragment, useCallback, useEffect, useMemo, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Text } from '@pixi/react';

import { getTextWidth } from '../../../core/helpers/getTextWidth';

const TextOrderingByWidth = observer(
  ({
    x = 0,
    y = 0,
    texts,
    space = 10,
    isCenter = true,
    InnerComp = null,
    innerCompIndex = null,
    innerWidth = 0,
  }) => {
    const ref = useRef();
    const textsWithWidth = useMemo(() => {
      return texts.map((el) => ({
        ...el,
        width: getTextWidth(el.text, el.style),
      }));
    }, [texts]);

    const calculatePosition = useCallback(
      (textIndex) => {
        return [...textsWithWidth]
          .slice(0, textIndex)
          .reduce((acc, current) => acc + current.width + space, 0);
      },
      [textsWithWidth, space]
    );

    useEffect(() => {
      if (!ref.current) {
        return;
      }
      if (isCenter) {
        ref.current.pivot.x = ref.current.width / 2;
      }
    }, [isCenter, texts]);

    return (
      <Container ref={ref} x={x} y={y}>
        {textsWithWidth.map((textObject, index) => {
          return (
            <Fragment key={textObject.id}>
              {InnerComp && innerCompIndex === index && (
                <InnerComp
                  xInner={
                    index
                      ? calculatePosition(index - 1) + textsWithWidth[index - 1].width + space
                      : 0
                  }
                />
              )}
              <Text
                resolution={2}
                key={textObject.id}
                ref={textObject.ref}
                text={textObject.text}
                style={textObject.style}
                anchor={{ x: 0, y: 0.5 }}
                x={
                  index
                    ? calculatePosition(index - 1) +
                      textsWithWidth[index - 1].width +
                      space +
                      innerWidth
                    : 0
                }
                y={textObject?.y ? textObject.y : 0}
              />
            </Fragment>
          );
        })}
      </Container>
    );
  }
);

export default TextOrderingByWidth;
